<section class="ar-model-container">
    <div class="ar-model">
        <h2 class="ar-model-title">Add IOS model</h2>
        <input type="file" multiple (change)="handleFileChange($event, 'ios')" accept=".usdz">
        <button mat-button type="submit"
                [disabled]="iosFile=== '' || isIOSUploading || !isIOSModelValid"
                [ngClass]="{'deactivated': iosFile === '' || isIOSUploading || !isIOSModelValid, 'activated': iosFile !== '' && !isIOSUploading && isIOSModelValid}"
                class="ar-model-submit-button"
                (click)="uploadModelFile(selectedFloorPlanId, 'ios')">
            {{isIOSUploading ? 'Uploading...' : 'Upload'}}
        </button>
    </div>
    <div class="ar-model">
        <h2 class="ar-model-title">Add Android model</h2>
        <input type="file" multiple (change)="handleFileChange($event, 'android')" accept=".gltf, .glb">
        <button mat-button type="submit"
                [disabled]="androidFile=== '' || isAndroidUploading || !isAndroidModelValid"
                [ngClass]="{'deactivated': androidFile === '' || isAndroidUploading || !isAndroidModelValid, 'activated': androidFile !== '' && !isAndroidUploading && isAndroidModelValid}"
                class="ar-model-submit-button"
                (click)="uploadModelFile(selectedFloorPlanId, 'android')">
            {{isAndroidUploading ? 'Uploading...' : 'Upload'}}
        </button>
    </div>
</section>
